export const STOP_INFO_COLUMNS = ["Tiempo", "Destino"];

export const BUS_LINES_LIMIT = {
  max_num_routes: 5,
};

export const STOP_SERVICE_REFRESH_TIME = 22000;
